import { get } from "lodash";

let configObject = {};

export default class Config {
	static get(key, defaultValue) {
		return get(configObject, key, defaultValue);
	}

	static populate(obj) {
		configObject = obj;
	}
}